import "../../css/mobile/MUserMailInquiryPg.css";
import MailInquiry from '../../assets/img/mailInquiry.png';
import MHeader from "../../components/mobile/MHeader";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import Expand from "../../assets/img/commonBottom.png";
import axios from '../../services/axiosInstance';
import withAuth from "../../auth/UserRouteAuth";
import {useWebSocket} from "../../services/WebsocketContext";
import domesticPickup from "../../assets/img/domesticPickup.png";
import DaumPostcode from "react-daum-postcode";
import commonSearch from "../../assets/img/commonSearch.png";

const MUserPickupRequestPg = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [memberInfo, setMemberInfo] = useState([]);
    const findMember = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberInfo(response.data)
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (LCAT || SSAT) {
            findMember();
        }
    }, [LCAT, SSAT])


    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!memberInfo.mbNum || isSubscribedRef.current) return;
            if (!stompClient && !isConnected) {
                await websocketConnect(memberInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [memberInfo.mbNum, isConnected, stompClient]);


    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [addressDt, setAddressDt] = useState("");
    const [telnum, setTelnum] = useState("");
    const [wid, setWid] = useState('');
    const [ver, setVer] = useState('');
    const [hei, setHei] = useState('');
    const [realWeight, setRealWeight] = useState('');
    const [isOpenPost, setIsOpenPost] = useState(false);

    const [nameError, setNameError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [addressDtError, setAddressDtError] = useState(false);
    const [telnumError, setTelnumError] = useState(false);
    const [volumeWeightError, setVolumeWeightError] = useState(false);
    const [realWeightError, setRealWeightError] = useState(false);

    const [isRequestBtLoading, setIsRequestBtLoading] = useState(false);
    const [requestFail, setRequestFail] = useState(false);


    const handleNameChange = (e) => {
        setNameError(false);
        setName(e);
    };

    const handleAddressChange = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';
        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress ? ', ' + data.buildingName : data.buildingName);
            }
            fullAddress += (extraAddress ? ' (' + extraAddress + ')' : '');
        }
        setAddress(fullAddress);
        setAddressError(false);
        setIsOpenPost(false);
    };

    const handleAddressDtChange = (e) => {
        setAddressDtError(false);
        setAddressDt(e);
    };

    function formatTelnum(value) {
        if (!value) return "";
        // 숫자만 추출
        value = value.replace(/[^0-9]/g, "");
        const len = value.length;

        if (len === 10) {
            // 3-3-4 (031-711-2222)
            return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        }
        if (len === 11) {
            // 3-4-4 (010-1234-5678, 031-1234-5678)
            return value.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        }
        if (len === 12) {
            // 4-4-4 (0507-1234-5678)
            return value.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
        }
        // 입력중일 때(아직 자리수 부족)
        if (len <= 3) return value;
        if (len <= 7) return value.replace(/(\d{3})(\d{0,4})/, "$1-$2");
        if (len <= 10) return value.replace(/(\d{3})(\d{3,4})(\d{0,4})/, "$1-$2-$3");
        if (len <= 12) return value.replace(/(\d{4})(\d{0,4})(\d{0,4})/, "$1-$2-$3");

        // 12자리 초과 입력시(입력 제한)
        return value.slice(0, 12);
    }

    const handleTelnumChange = (e) => {
        setTelnumError(false);
        const onlyNum = e.replace(/[^0-9]/g, "").slice(0, 12);
        setTelnum(onlyNum);
    };

    const handleWidChange = (e) => {
        setVolumeWeightError(false);
        setWid(e);
    };

    const handleVerChange = (e) => {
        setVolumeWeightError(false);
        setVer(e);
    };

    const handleHeiChange = (e) => {
        setVolumeWeightError(false);
        setHei(e);
    };

    const handleRealWeightChange = (e) => {
        setRealWeightError(false);
        setRealWeight(e);
    };


    const validation = (() => {
        if (!name) {
            setNameError(true);
            return false;
        }
        if (!address) {
            setAddressError(true);
            return false;
        }
        if (!addressDt) {
            setAddressDtError(true);
            return false;
        }
        if (!telnum) {
            setTelnumError(true);
            return false;
        }
        if (!wid) {
            setVolumeWeightError(true);
            return false;
        }
        if (!ver) {
            setVolumeWeightError(true);
            return false;
        }
        if (!hei) {
            setVolumeWeightError(true);
            return false;
        }
        if (!realWeight) {
            setRealWeightError(true);
            return false;
        }
        return true;
    })

    const savePickup = async () => {
        setIsRequestBtLoading(true);
        if (validation()) {
            axios({
                method: 'post',
                url: '/pickup/savePickup',
                data: {
                    memberDTO: memberInfo,
                    name: name,
                    address: address,
                    addressDt: addressDt,
                    telnum: telnum,
                    type: '1',
                    status: '0',
                    wid: wid,
                    ver: ver,
                    hei: hei,
                    realWeight: realWeight,
                }
            })
                .then(async (res) => {
                    await stompClient.send("/app/pickupAlarm", {}, JSON.stringify({sendFl: true}));
                    navigate("/UserPickupRequestComplPg");
                })
                .catch((error) => {
                    setIsRequestBtLoading(false);
                    setRequestFail(true);
                    setTimeout(() => setRequestFail(false), 2000);
                    console.log("신청실패 : ", error)
                })
        } else {
            setIsRequestBtLoading(false);
        }
    }

    const [shipFee, setShipFee] = useState(null);
    const selectedDomeShipFee = async () => {
        axios({
            method: 'post',
            url: '/pickup/selectedDomeShipFee',
            data: {
                wid: wid,
                ver: ver,
                hei: hei,
                realWeight: realWeight,
            }
        })
            .then(async (res) => {
                const data = res.data;
                setShipFee(data);
            })
            .catch((error) => {
                console.log("국내배송료 조회실패 : ", error)
            })
    }

    useEffect(() => {
        if (wid && ver && hei && realWeight) {
            selectedDomeShipFee();
        }
    }, [wid, ver, hei, realWeight]);



    return (
        <div className='m-a-mail-inquiry-pg-container font-t-cont'>
            <MHeader title={t('upr1')} url={"/"}/>
            <div className='m-a-mail-inquiry-sub-title'>
                <img className='m-a-mail-inquiry-sub-title-icon' src={domesticPickup} alt=''/>
                <div className='m-a-mail-inquiry-sub-title-text'>{t('upr1')}</div>
            </div>
            <div className='m-a-mail-inquiry-divider'/>

            {/*성함*/}
            <input className='m-a-mail-inquiry-input'
                   onChange={(e) => handleNameChange(e.target.value)}
                   type="text" placeholder={t('upr2')}
                   value={name} maxLength={20}/>
            {nameError &&
                <div className={'m-a-mail-inquiry-error'}>{t('upr3')}</div>
            }

            {/*주소*/}
            <div className="wd-100pc position-relative">
                <input className='m-a-mail-inquiry-input'
                       onClick={() => setIsOpenPost(true)}
                       onChange={(e) => setAddress(e.target.value)}
                       placeholder={t('upr4')}
                       value={address}
                       maxLength={300}
                       readOnly
                />
                <img onClick={() => setIsOpenPost(true)} src={commonSearch} alt="search"
                     className="position-absolute"
                     style={{right: "10px", top: "25%", width: "25px", height: "25px", opacity: 0.6}}/>
            </div>
            {addressError &&
                <div className={'m-a-mail-inquiry-error'}>{t('upr5')}</div>
            }

            {isOpenPost && (
                <div className="position-fixed user-center" style={{
                    left: 0,
                    top: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.4)",
                    zIndex: 9999,
                }}>
                    <div className="pd20 border-rd8" style={{background: "#fff"}}>
                        <DaumPostcode
                            onComplete={handleAddressChange}
                            autoClose
                            className="wd-400 ht-450"
                        />
                        <button className="mt10 border-rd20 c-point"
                                style={{
                                    background: "#FFBE48",
                                    border: "none",
                                    padding: "5px 10px",
                                }}
                                onClick={() => setIsOpenPost(false)}
                        >
                            <a style={{color: "white"}}>Close</a>
                        </button>
                    </div>
                </div>
            )}

            {/*상세주소*/}
            <input className='m-a-mail-inquiry-input'
                   onChange={(e) => handleAddressDtChange(e.target.value)}
                   type="text" placeholder={t('upr6')} value={addressDt} maxLength={50}/>
            {addressDtError &&
                <div className={'m-a-mail-inquiry-error'}>{t('upr7')}</div>
            }

            {/*연락처*/}
            <input className='m-a-mail-inquiry-input'
                   onChange={e => handleTelnumChange(e.target.value)}
                   type="text"
                   placeholder={t('upr8')}
                   value={formatTelnum(telnum)}
                   maxLength={14}
                   inputMode="numeric"
                   pattern="\d*"
                   autoComplete="tel"/>
            {telnumError &&
                <div className={'m-a-mail-inquiry-error'}>{t('upr9')}</div>
            }

            {/*부피&무게*/}
            <div className="display-flex align-center justify-content-between">
                {/*가로*/}
                <input className='m-a-mail-inquiry-input' style={{width: "32%"}}
                       onChange={e => handleWidChange(e.target.value)}
                       type="number"
                       placeholder={t('upr10')}
                       value={wid}
                       maxLength={3}
                       inputMode="numeric"/>
                {/*세로*/}
                <input className='m-a-mail-inquiry-input' style={{width: "32%"}}
                       onChange={e => handleVerChange(e.target.value)}
                       type="number"
                       placeholder={t('upr11')}
                       value={ver}
                       maxLength={3}
                       inputMode="numeric"/>
                {/*높이*/}
                <input className='m-a-mail-inquiry-input' style={{width: "32%"}}
                       onChange={e => handleHeiChange(e.target.value)}
                       type="number"
                       placeholder={t('upr12')}
                       value={hei}
                       maxLength={3}
                       inputMode="numeric"/>
                {volumeWeightError &&
                    <div className={'m-a-mail-inquiry-error'}>{t('upr13')}</div>
                }
            </div>


            {/*실무게*/}
            <input className='m-a-mail-inquiry-input'
                   onChange={e => {
                       // 정수 또는 소수점 1개만 허용
                       const val = e.target.value;
                       if (val === '' || /^[0-9]*\.?[0-9]*$/.test(val)) {
                           handleRealWeightChange(val);
                       }
                   }}
                   type="text"
                   placeholder={t('upr14')}
                   value={realWeight}
                   maxLength={6}
                   inputMode="decimal"
                   autoComplete="off"/>
            {realWeightError &&
                <div className={'m-a-mail-inquiry-error'}>{t('upr15')}</div>
            }

            <div className="wd-100pc display-flex align-center justify-content-between font-s-14"
                 style={{backgroundColor: "#FFF7EA", borderRadius: "6px", padding: "10px"}}>
                <a style={{color: "#FFBE48"}}>{t('upr16')}</a>
                <a style={{color: "#FFBE48"}}>
                    {shipFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || 0}
                </a>
            </div>

            <div className='m-a-mail-inquiry-button m-t-10'
                 onClick={savePickup}>
                {isRequestBtLoading ? (
                    <div className='m-a-small-spinner'/>
                ) : (
                    <div>{t('upr17')}</div>
                )}
            </div>
            {requestFail &&
                <div className={'m-a-mail-inquiry-error'}>{t('umiErr4')}</div>
            }
        </div>
    )
}

export default withAuth(MUserPickupRequestPg);
